import { useContext } from 'react'
import { DarkThemeContext } from './DarkTheme'

const SimpleBackground = () => {
  const { bgColor } = useContext(DarkThemeContext)

  return (
    <div className="fixed inset-0 h-full">
      <div className={`h-full w-full ${bgColor} transition-all duration-300`} />
    </div>
  )
}

export default SimpleBackground
